import { GLYPH_FONTS } from '@/lib/glyph-markers-constants'

export const ONXFONT_API_PATH = `/onxfonts/v2/`

// Retrieve glyph fonts from carto endpoint.
// Create and append style tags with those fonts to the DOM
/**
 * *(AI-generated)*
 * Fetches glyph fonts from the ONX fonts API and injects @font-face style tags into the document.
 */
export function fetchGlyphs(): void {
  const fonts = Object.values(GLYPH_FONTS)
  fonts.forEach((font: string): void => {
    const url = `${window.environment.apiUrl}${ONXFONT_API_PATH}${font}.ttf`
    const styleEl: HTMLStyleElement = document.createElement('style')
    styleEl.appendChild(
      document.createTextNode(
        `@font-face {
          font-family: ${font};
          src: url(${url});
        }`
      )
    )
    document.body.appendChild(styleEl)
  })
}
